import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const Approval = () => {
  const { auth } = useAuth();

  return (
    auth?.user && (
      <section id="content" className="content">
        <div className="content__header content__boxed overlapping">
          <div className="content__wrap">
            {/* <!-- Page title and information --> */}
            <h1 className="page-title mb-2">My Approvals</h1>
            <h2 className="h5">Approve pending requests</h2>
            {/* <!-- END : Page title and information --> */}
          </div>
        </div>

        <div>
          <div className="content__boxed">
            <div className="content__wrap">
              {/* <!-- Infographics --> */}
              <div className="row my-3">
                <div className="col-md-4 col-lg-3">
                  <Link
                    to="/commissions/deferred"
                    className="text-decoration-none"
                  >
                    <div className="card text-center mb-3 mb-md-0">
                      <div className="card-body">
                        {/* <div className="h1 my-4">
                          <i className="demo-psi-data-settings display-3 text-head text-opacity-20"></i>
                        </div> */}
                        <p className="h4">Deferred Commissions</p>

                        <small
                          className="d-block text-muted my-3"
                          style={{ height: 40 }}
                        >
                          Policy items with deferred commissions
                        </small>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="col-md-4 col-lg-3">
                  <Link
                    to="/policies/revoke-requests"
                    className="text-decoration-none"
                  >
                    <div className="card text-center mb-3 mb-md-0">
                      <div className="card-body">
                        {/* <div className="h1 my-4">
                          <i className="demo-psi-data-settings display-3 text-head text-opacity-20"></i>
                        </div> */}
                        <p className="h4">Revoke Policies</p>

                        <small
                          className="d-block text-muted my-3"
                          style={{ height: 40 }}
                        >
                          Revoke Policy items for amendments
                        </small>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              {/* <!-- END : Infographics --> */}
            </div>
          </div>
        </div>
      </section>
    )
  );
};

export default Approval;
